// extracted by mini-css-extract-plugin
export default {"price":"d7-z","onSale":"e7-z","msrpLabelPrice":"f7-z","msrpLabel":"g7-z","originalPrice":"h7-z","percentOff":"i7-z"};